import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { Pedido } from '../../pedido';
import { ABRIR_DETALHADO } from '../drp-linhas';
import { PedidoItemDRPViewComponent } from '../item/view';

@Component({
    selector: 'sgt-drp-view',
    templateUrl: './drp-view.component.html',
    styleUrls: ['./drp-view.component.less']
})
export class DRPViewComponent implements OnInit {
    /** Título do collapse group do DRP do pedido */
    @Input() titlePedidoGroup = 'Pedido';
    /** Título do collapse group do DRP dos itens do pedido */
    @Input() titleItensGroup = 'Itens';
    /** Pedido para exibir o DRP */
    @Input() pedido: Pedido;

    /** View do DRP dos itens do pedido */
    @ViewChild('itemView') itemView: PedidoItemDRPViewComponent;

    /** Se as duas tabelas mostram os componentes do D.R.P ou apenas as etapas da cascata */
    detalhado = ABRIR_DETALHADO;
    /** Sem acesso aos custos não há componente para abrir, então o botão não aparece */
    canShowDRPCustos = false;

    constructor(private authService: AuthService) { }

    ngOnInit() {
        this.canShowDRPCustos = this.authService.podeVisualizarDRPCustos();
    }

    /** Alterna as duas tabelas entre a visão detalhada e a resumida */
    alternarDetalhe() {
        this.detalhado = !this.detalhado;
    }


    /** Atualiza a table o DRP do pedido */
    refresh() {
        // Itens
        this.itemView?.refresh();
    }
}
